import styled from 'styled-components';

export const StyledHeader = styled.header`
  flex: 0 1 auto;
  margin-left: auto;
  color: white;
  margin-bottom: 10px;
`;
